import { useCallback } from 'react';

export const usePriceFormatting = () => {
  const formatPrice = useCallback((amount: number, currency: string) => {
    return new Intl.NumberFormat('en-US', { currency, style: 'currency' }).format(amount / 100);
  }, []);

  const calculateVATPercentage = useCallback((taxAmount: number | undefined, totalAmount: number) => {
    if (!taxAmount || taxAmount === 0) return '0%';
    const subtotal = totalAmount - taxAmount;
    if (subtotal === 0) return '0%';
    const percentage = (taxAmount / subtotal) * 100;
    return `${Math.round(percentage)}%`;
  }, []);

  return { calculateVATPercentage, formatPrice };
};
